var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none",
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#173042",
    d: "M17.577 13.514c-.176 0-.346.069-.47.19-.125.123-.195.288-.196.46l.015 2.068h-6.574l-5.578.012v-2.078c-.007-.168-.08-.327-.204-.443-.124-.116-.29-.181-.46-.181-.173 0-.338.065-.462.18-.124.117-.197.276-.204.444v2.082c0 .34.139.665.384.906.245.24.578.377.925.378h12.174c.348 0 .682-.136.929-.377.246-.24.385-.567.386-.908v-2.081c0-.086-.017-.17-.05-.25-.034-.078-.083-.15-.145-.21-.061-.061-.135-.11-.215-.142-.081-.033-.168-.05-.255-.05z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#173042",
    d: "M10.422 3.361L8.785 5.496c-.06.077-.097.169-.106.265-.01.097.008.194.052.281.044.087.112.16.196.212.084.051.181.079.28.079h.883l-.03 7.027c0 1.16 1.53 1.027 1.53.128v-7.14l.897-.015c.1 0 .197-.027.282-.078.084-.051.153-.124.197-.211.044-.087.063-.185.054-.282-.01-.096-.046-.189-.106-.266L11.276 3.36c-.05-.065-.114-.118-.188-.154-.074-.036-.156-.055-.239-.055-.083 0-.164.019-.239.055-.074.036-.138.09-.188.154z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default ForwardRef;